module.exports = __webpack_public_path__ + "media/app/assets/imgs/refresh-fba395929d7a3b5cea9a18506a9053e9.svg";